import "./PrivacyPolicyView.scss"

function PrivacyPolicyView() {
  function scrollIntoView(id: string) {
    document.querySelector(`#${id}`)?.scrollIntoView()
  }
  return (
    <section className="policy">
      <div className="policy__container">
        <h2 className="h2 policy__h2">
          <strong className="uppercase">Политика конфиденциальности</strong>
          <br />в отношении обработки персональных данных
        </h2>

        <time className="date" dateTime="2021-03-25">
          Дата публикации: « 25 » Марта, 2021 г.
        </time>

        <ol className="list">
          <li className="item">
            <div
              className="link"
              onClick={() => scrollIntoView("general-provisions")}
            >
              1. Общие положения
            </div>
          </li>
          <li className="item">
            <div
              className="link"
              onClick={() => scrollIntoView("basic-concepts")}
            >
              2. Основные понятия, используемые в Политике
            </div>
          </li>
          <li className="item">
            <div
              className="link"
              onClick={() => scrollIntoView("personal-information")}
            >
              3. Персональные данные Пользователя, которые обрабатывает
              Оператор
            </div>
          </li>
          <li className="item">
            <div
              className="link"
              onClick={() =>
                scrollIntoView("purposes-of-processing-personal-data")
              }
            >
              4. Цели обработки персональных данных
            </div>
          </li>
          <li className="item">
            <div
              className="link"
              onClick={() => scrollIntoView("user-consent")}
            >
              5. Согласие Пользователя. Правовые основания обработки
              персональных данных.
            </div>
          </li>
          <li className="item">
            <div className="link" onClick={() => scrollIntoView("security")}>
              6. Безопасность, порядок и условия сбора, хранения, передачи и
              других видов обработки персональных данных
            </div>
          </li>
          <li className="item">
            <div
              className="link"
              onClick={() => scrollIntoView("responsibility")}
            >
              7. Ответственность
            </div>
          </li>
          <li className="item">
            <div
              className="link"
              onClick={() => scrollIntoView("final-provisions")}
            >
              8. Заключительные положения
            </div>
          </li>
        </ol>

        <h3 id="general-provisions" className="h3 policy__h3">
          1. Общие положения
        </h3>

        <p className="text">
          <b className="text-number">1.1.</b> Настоящая политика
          конфиденциальности в отношении обработки персональных данных (далее
          – «Политика») составлена в соответствии с требованиями
          законодательства и определяет порядок обработки персональных данных
          и меры по обеспечению безопасности персональных данных со стороны
          Общества с ограниченной ответственностью «Транспортно-туристическая
          компания МерЛайнс» (далее – «Оператор»).
        </p>
        <p className="text">
          <b className="text-number">1.2.</b> Оператор ставит своей важнейшей
          целью и условием осуществления своей деятельности соблюдение прав и
          свобод человека и гражданина при обработке его персональных данных,
          в том числе защиты прав на неприкосновенность частной жизни, личную
          и семейную тайну.
        </p>
        <p className="text">
          <b className="text-number">1.3.</b> Настоящая Политика применяется
          ко всей информации, которую Оператор может получить о посетителях
          Сервиса. Используя Сервис и предоставляя свои персональные данные
          Оператору, Пользователь дает согласие на обработку персональных
          данных в соответствии с данной Политикой, подтверждает, что
          ознакомлен со всеми пунктами настоящей Политики и принимает их без
          исключений и оговорок.
        </p>

        <h3 id="basic-concepts" className="h3 policy__h3">
          2. Основные понятия, используемые в Политике
        </h3>

        <p className="text">
          <b className="text-number">2.1.</b> Сервис – интернет-ресурс,
          располагаемый по сетевому адресу{" "}
          <a className="text-link" href="https://merlines.ru">
            https://merlines.ru
          </a>
          , администрируемый Оператором. Сервис имеет десктопную и мобильную
          версию в форме приложения «Merlines», предназначенное для работы на
          смартфонах, планшетах, других мобильных устройствах и опубликованное
          в Google Play и App Store. Право собственности на Сервис принадлежит
          Оператору.
        </p>
        <p className="text">
          <b className="text-number">2.2.</b> Обработка персональных данных –
          любое действие (операция) или совокупность действий (операций),
          совершаемых с использованием средств автоматизации или без
          использования таких средств с персональными данными, включая сбор,
          запись, систематизацию, накопление, хранение, уточнение (обновление,
          изменение), извлечение, использование, передачу (распространение,
          предоставление, доступ), обезличивание, блокирование, удаление,
          уничтожение персональных данных.
        </p>
        <p className="text">
          <b className="text-number">2.3.</b> Оператор – ООО
          «Транспортно-туристическая компания МерЛайнс», самостоятельно или
          совместно с другими лицами организующее и (или) осуществляющее
          обработку персональных данных, а также определяющий цели обработки
          персональных данных, состав персональных данных, подлежащих
          обработке, действия (операции), совершаемые с персональными данными.
        </p>
        <p className="text">
          <b className="text-number">2.4.</b> Персональные данные – любая
          информация, относящаяся прямо или косвенно к определенному или
          определяемому Пользователю Сервиса.
        </p>
        <p className="text">
          <b className="text-number">2.5.</b> Пользователь – посетитель
          Сервиса, заказавший и/или планирующий заказать и/или заказывающий
          Услуги у Оператора.
        </p>
        <p className="text">
          <b className="text-number">2.6.</b> Услуги – услуги, оказываемые
          Оператором посредством Сервиса (услуги по поиску Пользователем
          билетов на авиа, железнодорожный и автобусный транспорт в РФ и
          зарубежье с предоставлением последующей возможности забронировать и
          оплатить их через продавцов (агентства, авиакомпании, сервисы
          бронирования, напрямую у перевозчиков). Полная информация об Услугах
          указана на Сервисе.
        </p>
        <p className="text">
          <b className="text-number">2.7.</b> Файл «cookie» - файл, который
          сохраняется на компьютере или мобильном устройстве Пользователя,
          который веб-клиент или веб-браузер каждый раз пересылает веб-серверу
          в HTTP-запросе при попытке открыть страницу соответствующего
          Сервиса.
        </p>

        <h3 id="personal-information" className="h3 policy__h3">
          3. Персональные данные Пользователя, которые обрабатывает Оператор
        </h3>

        <p className="text">
          <b className="text-number">3.1.</b> Оператор обрабатывает
          персональную информацию, которую Пользователь предоставляет о себе
          самостоятельно в процессе использования Сервиса, включая
          персональные данные Пользователя. В частности, Оператор получает и
          обрабатывает следующие данные Пользователя, указанные им в формах,
          размещенных на Сервисе: ФИО и адрес электронной почты.
        </p>
        <p className="text">
          <b className="text-number">3.2.</b> На Сервисе происходит сбор и
          обработка обезличенных данных о посетителях (файлы «cookie»,
          сведения о местоположении, тип и версия ОС, тип и версия браузера,
          IP-адрес, время, проведенное Пользователем в приложении, сведения об
          ошибках, происходящих в приложении).
        </p>
        <p className="text">
          <b className="text-number">3.3.</b> Файлы «cookie» используются для
          персонализации материалов, настройки и измерения показателей
          рекламы, для обеспечения безопасности Сервиса и его Пользователей,
          улучшения и упрощения процесса посещения Сервиса. Владелец сервиса
          обрабатывает обезличенные данные о Пользователе в случае, если это
          разрешено в настройках браузера Пользователя (включено сохранение
          файлов «cookie» и использование технологии JavaScript). Владелец
          сервиса не использует файлы «cookie» для хранения персональной
          информации или раскрытия информации третьим сторонам. Подробная
          информация о политике применения файлов «cookie» указана на странице
          Сервиса{" "}
          <a className="text-link" href="https://merlines.ru/police">
            https://merlines.ru/police
          </a>
          .
        </p>
        <p className="text">
          <b className="text-number">3.4.</b> При загрузке мобильного
          приложения Пользователь отправляет свой идентификационный номер
          мобильного устройства.
        </p>
        <p className="text">
          <b className="text-number">3.5.</b> Техническую информацию о
          скачивании и загрузке мобильного приложения (обезличенную) собирают
          установленные счетчики для составления статистики.
        </p>
        <p className="text">
          <b className="text-number">3.6.</b> Оператор использует Google
          Analytics и Яндекс.Метрику для анализа посещаемости Сервиса. Google
          Analytics и Яндекс.Метрика формируют статистическую и другую
          информацию о Сервисе, используя файлы «cookie», которые хранятся в
          компьютерах Пользователя. Эта информация используется для
          составления отчетов об использовании Сервиса. Полученные данные
          хранятся в Google и Яндекс.
        </p>
        <p className="text">
          <b className="text-number">3.7.</b> В общем случае Оператор не
          проверяет достоверность персональной информации, предоставляемой
          Пользователем, и не осуществляет контроль за их дееспособностью.
          Однако Оператор исходит из того, что Пользователь предоставляет
          достоверную и достаточную персональную информацию по вопросам,
          предлагаемым в форме регистрационных данных, обратной связи и
          поддерживает эту информацию в актуальном состоянии.
        </p>
        <p className="text">
          <b className="text-number">3.8.</b> Настоящая Политика применяется
          только к Сервису. Оператор не контролирует и не несет
          ответственность за сервисы третьих лиц, на которые Пользователь
          может перейти по ссылкам, доступным на Сервисе.
        </p>

        <h3 id="basic-concepts" className="h3 policy__h3">
          4. Цели обработки персональных данных
        </h3>

        <p className="text">
          <b className="text-number">4.1</b> Оператор собирает и хранит только
          те персональные данные, которые необходимы для оказания Услуг.
        </p>
        <p className="text">
          <b className="text-number">4.2.</b> Цели обработки персональных
          данных Пользователя:
        </p>
        <p className="text">
          <b className="text-number">4.2.1</b> Оказание Услуг Пользователям.
        </p>
        <p className="text">
          <b className="text-number">4.2.2</b> Ассоциирование истории поиска
          информации.
        </p>
        <p className="text">
          <b className="text-number">4.2.3</b> Таргетирование рекламных
          материалов.
        </p>
        <p className="text">
          <b className="text-number">4.2.4</b> Предоставление Пользователю
          доступа к информации, содержащейся на Сервисе.
        </p>
        <p className="text">
          <b className="text-number">4.2.5</b> Связь с Пользователем, в том
          числе направление уведомлений, запросов и информации (рассылок),
          касающихся оказания Услуг.
        </p>
        <p className="text">
          <b className="text-number">4.2.6</b> Улучшение качества Сервиса,
          удобства его использования, разработка новых Сервисов и услуг.
        </p>
        <p className="text">
          <b className="text-number">4.2.7</b> Улучшение поиска информации в
          зависимости от предпочтений Пользователя.
        </p>
        <p className="text">
          <b className="text-number">4.2.8</b> Рекламирование и продвижение на
          рынке Услуг, предоставляемых Оператором посредством Сервиса.
        </p>
        <p className="text">
          <b className="text-number">4.2.9</b> Проведение статистических и
          иных исследований на основе обезличенных данных.
        </p>

        <h3 className="h3 policy__h3" id="user-consent">
          {" "}
          5. Согласие Пользователя. Правовые основания обработки персональных
          данных.
        </h3>

        <p className="text">
          <b className="text-number">5.1.</b> Оператор обрабатывает
          персональные данные Пользователя только в случае их заполнения и/или
          отправки Пользователем самостоятельно через специальные формы,
          расположенные на Сервисе.
        </p>
        <p className="text">
          <b className="text-number">5.2.</b> Заполняя добровольно
          соответствующие формы и/или отправляя свои персональные данные
          Оператору, Пользователь выражает свое согласие с данной Политикой.
          Согласие Пользователя на обработку персональных данных является
          конкретным, информированным и сознательным. Настоящее Согласие
          Пользователя признается исполненным в простой письменной форме.
        </p>
        <p className="text">
          <b className="text-number">5.3.</b> В случае, если Пользователь не
          дает Согласия, это автоматически влечет невозможность надлежащего
          оформления заявок Пользователя, и, как следствие, невозможность
          полноценного оказания Услуг, дальнейшего использования Сервиса и
          предоставляемой им информации, поскольку Оператор не сможет
          продолжить выполнять условия без нарушения закона.
        </p>
        <p className="text">
          <b className="text-number">5.4.</b> Пользователь как субъект
          персональных данных имеет право на получение информации, касающейся
          обработки его персональных данных, в том числе содержащей:
        </p>
        <ul>
          <li>подтверждение факта обработки персональных данных;</li>
          <li>правовые основания и цели обработки персональных данных;</li>
          <li>
            цели и применяемые оператором способы обработки персональных
            данных;
          </li>
          <li>
            наименование и место нахождения оператора, сведения о лицах (за
            исключением работников оператора), которые имеют доступ к
            персональным данным или которым могут быть раскрыты персональные
            данные на основании договора с оператором или на основании
            федерального закона №152-ФЗ;
          </li>
          <li>
            обрабатываемые персональные данные, относящиеся к соответствующему
            субъекту персональных данных, источник их получения, если иной
            порядок представления таких данных не предусмотрен федеральным
            законом №152-ФЗ;
          </li>
          <li>
            сроки обработки персональных данных, в том числе сроки их
            хранения;
          </li>
          <li>
            порядок осуществления субъектом персональных данных прав,
            предусмотренных Федеральным законом;
          </li>
          <li>
            информацию об осуществленной или о предполагаемой трансграничной
            передаче данных;
          </li>
          <li>
            наименование или фамилию, имя, отчество и адрес лица,
            осуществляющего обработку персональных данных по поручению
            Оператора, если обработка поручена или будет поручена такому лицу;
          </li>
          <li>иные сведения, предусмотренные федеральными законами.</li>
        </ul>

        <h3 className="h3 policy__h3" id="security">
          {" "}
          6. Безопасность, порядок и условия сбора, хранения, передачи и
          других видов обработки персональных данных
        </h3>
        <p className="text">
          <b className="text-number">6.1.</b> Безопасность персональных
          данных, обрабатываемых Оператором, обеспечивается путем реализации
          правовых, организационных и технических мер, необходимых для
          выполнения в полном объеме требований действующего законодательства
          в области защиты персональных данных.
        </p>
        <p className="text">
          <b className="text-number">6.2.</b> Обработка персональных данных
          Пользователя осуществляется любым законным способом, в том числе в
          информационных системах персональных данных с использованием средств
          автоматизации или без использования таких средств.
        </p>
        <p className="text">
          <b className="text-number">6.3.</b> В отношении персональной
          информации Пользователя сохраняется ее конфиденциальность. Оператор
          обеспечивает сохранность персональных данных и принимает все
          возможные меры, исключающие доступ к персональным данным
          неуполномоченных лиц.
        </p>
        <p className="text">
          <b className="text-number">6.4.</b> Персональные данные Пользователя
          никогда, ни при каких условиях не будут переданы третьим лицам, за
          исключением следующих случаев:
        </p>
        <p className="text">
          <b className="text-number">6.4.1</b> Пользователь выразил свое
          согласие на такие действия.
        </p>
        <p className="text">
          <b className="text-number">6.4.2</b> Передача необходима в рамках
          использования Пользователем Сервиса либо для оказания Услуг
          Пользователю.
        </p>
        <p className="text">
          <b className="text-number">6.4.3</b> Передача предусмотрена
          российским или иным применимым законодательством в рамках
          установленной законодательством процедуры.
        </p>
        <p className="text">
          <b className="text-number">6.4.4</b> Такая передача происходит в
          рамках продажи или иной передачи бизнеса (полностью или в части),
          при этом к приобретателю переходят все обязательства по соблюдению
          условий настоящей Политики применительно к полученной им
          персональной информации.
        </p>
        <p className="text">
          <b className="text-number">6.5.</b> Доступ к персональным данным
          имеют только уполномоченные сотрудники Оператора. Все сотрудники
          Оператора, имеющие доступ к персональным данным, должны
          придерживаться Политики. В целях обеспечения конфиденциальности
          информации и защиты персональных данных Оператор принимает все меры,
          необходимые для предотвращения несанкционированного доступа.
        </p>
        <p className="text">
          <b className="text-number">6.6.</b> При утрате или разглашении
          персональных данных Оператор информирует Пользователя об утрате или
          разглашении персональных данных.
        </p>
        <p className="text">
          <b className="text-number">6.7.</b> В случае выявления неточностей в
          персональных данных, Пользователь может актуализировать (изменить,
          обновить, дополнить) их самостоятельно в личном кабинете
          пользователя или путем отправки Оператору письма-уведомления на
          адрес электронной почты Оператора contact@merlines.ru с пометкой
          «Актуализация/изменение персональных данных».
        </p>
        <p className="text">
          <b className="text-number">6.8.</b> Срок обработки персональных
          данных является неограниченным. Пользователь может в любой момент
          отозвать свое согласие на обработку персональных данных, направив
          Оператору письмо-уведомление посредством электронной почты на
          электронный адрес Оператора contact@merlines.ru с пометкой «Отзыв
          согласия на обработку персональных данных».
        </p>
        <p className="text">
          <b className="text-number">6.9.</b> Письма-уведомления, указанные в
          п. 6.7. - 6.8. Политики, могут быть также направлены на бумажном
          носителе Пользователем по адресу: 236006, Калининградская область,
          г. Калининград, Московский проспект, д.201, офис 205.
        </p>
        <p className="text">
          <b className="text-number">6.10.</b> Оператор совместно с
          Пользователем принимает все необходимые меры по предотвращению
          убытков или иных отрицательных последствий, вызванных утратой или
          разглашением персональных данных Пользователя.
        </p>
        <p className="text">
          <b className="text-number">6.11.</b> Удаление, уничтожение,
          персональных данных осуществляются в порядке, предусмотренном
          действующим законодательством и нормативными актами Оператора.
          Удаление, уничтожение персональных данных осуществляется
          ответственными лицами:
        </p>
        <ul style={{ listStyle: "none" }}>
          <li>
            <b className="text-number">6.11.1</b>в случаях, предусмотренных
            законом;
          </li>
          <li>
            <b className="text-number">6.11.2</b>по требованию Пользователя,
            государственного органа или суда;
          </li>
          <li>
            <b className="text-number">6.11.3</b>по истечении сроков хранения;
          </li>
          <li>
            <b className="text-number">6.11.4</b>за истечением надобности.
          </li>
        </ul>

        <h3 className="h3 policy__h3" id="responsibility">
          {" "}
          7. Ответственность
        </h3>
        <p className="text">
          <b className="text-number">7.1.</b> Политика конфиденциальности не
          регулирует и Оператор не несет ответственности за получение,
          хранение, обработку, использование и раскрытие персональных данных
          Пользователя третьими лицами, не находящимися во владении или под
          управлением Оператора, и физическими лицами, не являющимися
          работниками/партнерами Оператора, даже если Пользователь получил
          доступ к веб-Сервисам товаров или услуг этих лиц с помощью Сервиса
          или рассылки.
        </p>
        <p className="text">
          <b className="text-number">7.2.</b> Пользователь признает, что в
          случае халатного отношения Пользователя к безопасности и защите
          своих персональных данных и данных авторизации, третьи лица могут
          получить несанкционированный доступ к учетной записи, персональным и
          другим данным Пользователя. В данном случае Оператор не несет
          ответственности за убытки, причиненные Пользователю и/или третьим
          лицам таким доступом.
        </p>
        <p className="text">
          <b className="text-number">7.3.</b> В случае утраты или разглашения
          конфиденциальной информации Оператор не несёт ответственность, если
          данная информация:
        </p>
        <ul style={{ listStyle: "none" }}>
          <li>стала публичным достоянием до её утраты или разглашения;</li>
          <li>
            была получена от третьей стороны до момента её получения
            Оператором;
          </li>
          <li>была разглашена с согласия Пользователя.</li>
        </ul>
        <p className="text">
          <b className="text-number">7.4.</b> Оператор не несет
          ответственности за ущерб или убытки, которые понес Пользователь
          и/или третьи лица в результате ошибочного понимания или непонимания
          условий Политики, инструкций или указаний о порядке использования
          Сервиса, относительно порядка размещения данных и других технических
          вопросов.
        </p>

        <h3 className="h3 policy__h3" id="final-provisions">
          {" "}
          8. Заключительные положения
        </h3>
        <p className="text">
          <b className="text-number">8.1.</b> Пользователь может получить
          любые разъяснения по интересующим вопросам, касающимся обработки его
          персональных данных, обратившись к Оператору по электронной почте
          contact@merlines.ru.
        </p>
        <p className="text">
          <b className="text-number">8.2.</b> Оператор имеет право вносить
          изменения в настоящую Политику в любое время и по своему усмотрению.
          При внесении изменений в актуальной редакции указывается дата
          последнего обновления. Новая редакция Политики вступает в силу с
          момента ее размещения на веб-Сервисе, если иное не предусмотрено
          новой редакцией Политики.
        </p>
        <p className="text">
          <b className="text-number">8.3.</b> Действующая редакция Политики
          находится на странице Сервиса https://merlines.ru/police.
        </p>
        <p className="text">
          <b className="text-number">8.4.</b> Настоящая Политика применима
          только к Сервису.
        </p>
        <p className="text">
          <b className="text-number">8.5.</b> Политика распространяется на
          Пользователя с момента, когда во время использования Сервиса он при
          передаче своих персональных данных согласился с условиями Политики,
          и действует до тех пор, пока у Оператора хранится любая информация о
          Пользователе, в том числе, персональные данные.
        </p>
        <p className="text">
          <b className="text-number">8.6.</b> В случае, если какое-либо
          положение Политики, включая любое предложение, пункт или их часть,
          признается противоречащим закону или недействительным, это не
          повлияет на остальные положения, которые не противоречат закону, они
          остаются в полной силе и являются действительными, а любое
          недействительное положение или положение, которое не может быть
          выполнено без дальнейших действий Сторон, считается измененным,
          исправленным в той мере, в какой это необходимо для обеспечения его
          действительности и возможности выполнения.
        </p>
        <p className="text">
          <b className="text-number">8.7.</b> Оператор не принимает
          предложения от Пользователей относительно изменений настоящей
          Политики.
        </p>
        <p className="text">
          <b className="text-number">8.8.</b> Все споры между сторонами
          решаются путем переговоров. Претензионный порядок решения споров
          является обязательным, срок ответа на претензию составляет 10
          (десять) рабочих дней.
        </p>
        <p className="text">
          <b className="text-number">8.9.</b> В случае невозможности
          достижения согласия путем переговоров, споры решаются в судебном
          порядке по месту нахождения Оператора.
        </p>
      </div>
    </section>
  )
}

export default PrivacyPolicyView